import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ClienteLayout from '../../components/ClienteLayout'
import { useAuth } from '../../lib/AuthContext'
import { getMisSuscripciones, getDashboardResumen } from '../../lib/portalClienteApi'

const COMO_FUNCIONA = [
  { icon: '🏠', titulo: 'Vivís en una cuadra', texto: 'Cuando te suscribís, registramos tu cuadra para contar vecinos.' },
  { icon: '👋', titulo: 'Invitás a tus vecinos', texto: 'Compartí el link por WhatsApp. Si se suscriben con tu invitación, cuentan para tu cuadra.' },
  { icon: '🎉', titulo: 'Llegan a 10 = todos ganan', texto: 'Cuando hay 10 suscriptores activos en la cuadra, todos pasan a tener 5% off permanente.' },
]

const FAQ = [
  { q: '¿Qué cuenta como "vecino de mi cuadra"?', a: 'Alguien que viva sobre tu misma calle, en el tramo entre las dos esquinas más cercanas a tu casa. Lo validamos automáticamente con la dirección al suscribirse.' },
  { q: '¿El descuento es permanente?', a: 'Sí, mientras la cuadra mantenga al menos 10 suscriptores activos. Si alguno se baja y quedan menos de 10, vuelve la tarifa normal hasta llegar de nuevo.' },
  { q: '¿Puedo invitar a mi familia que vive lejos?', a: 'Sí, pero solo cuentan para tu cuadra los que viven en tu zona. El resto sigue siendo cliente Limpack pero con tarifa normal.' },
]

export default function Vecinos() {
  const { user, profile } = useAuth()
  const [resumen, setResumen] = useState(null)
  const [cargando, setCargando] = useState(true)

  useEffect(() => { if (user?.id) cargar() }, [user?.id])

  async function cargar() {
    setCargando(true)
    const ss = await getMisSuscripciones(user.id)
    if (ss[0]) {
      const r = await getDashboardResumen(ss[0].id)
      setResumen(r)
    }
    setCargando(false)
  }

  const cuadra = Number(resumen?.vecinos?.cuadra || 1)
  const paraDescuento = Number(resumen?.vecinos?.paraDescuento || 10)
  const progress = Math.min(100, (cuadra / paraDescuento) * 100)
  const yaTieneDescuento = cuadra >= paraDescuento

  function handleInvitar() {
    const nombre = profile?.nombre?.split(' ')[0] || 'Yo'
    const msg = encodeURIComponent(
      `Hola! Me sumé a Limpack — me llevan los productos de limpieza al barrio cada mes a 10% abajo del súper. Si nos suscribimos varios vecinos en la cuadra, todos ganamos 5% extra. ¿Te animás? https://limpack.uy`
    )
    window.open(`https://wa.me/?text=${msg}`, '_blank')
  }

  return (
    <ClienteLayout title="Vecinos">
      <div className="vc-wrap">
        <div className="vc-headline">
          <h1>Vecinos en tu cuadra</h1>
          <p>Si llegan a {paraDescuento}, todos ganan 5% de descuento permanente.</p>
        </div>

        {/* Hero verde con barra */}
        <div className="vc-hero">
          <div className="vc-hero-top">
            <div className="vc-hero-num">{cargando ? '…' : cuadra}</div>
            <div className="vc-hero-info">
              <div className="vc-hero-h">
                {yaTieneDescuento
                  ? '🎉 ¡Llegaron a la meta!'
                  : cuadra === 1
                    ? 'Sos el primero en tu cuadra'
                    : `Ya son ${cuadra} en tu cuadra`}
              </div>
              <div className="vc-hero-sub">
                {yaTieneDescuento
                  ? `Tu cuadra tiene 5% off activo. Mientras se mantengan ${paraDescuento} o más, el descuento sigue.`
                  : `Faltan ${paraDescuento - cuadra} vecino${paraDescuento - cuadra === 1 ? '' : 's'} para que toda la cuadra tenga 5% off permanente.`}
              </div>
            </div>
          </div>
          <div className="vc-bar"><div className="vc-bar-fill" style={{ width: `${progress}%` }} /></div>
          <div className="vc-bar-meta">
            <span>{cuadra} suscripto{cuadra === 1 ? '' : 's'}</span>
            <span>{paraDescuento} para descuento</span>
          </div>
          <button className="vc-cta" onClick={handleInvitar}>
            <span>💬</span>
            Invitar vecino por WhatsApp
          </button>
        </div>

        {/* Cómo funciona */}
        <h2 className="vc-section">Cómo funciona</h2>
        <div className="vc-steps">
          {COMO_FUNCIONA.map((s, i) => (
            <div className="vc-step" key={i}>
              <div className="vc-step-num">{i + 1}</div>
              <div className="vc-step-icon">{s.icon}</div>
              <div className="vc-step-titulo">{s.titulo}</div>
              <div className="vc-step-texto">{s.texto}</div>
            </div>
          ))}
        </div>

        {/* FAQ */}
        <h2 className="vc-section">Preguntas frecuentes</h2>
        <div className="vc-faq">
          {FAQ.map((f, i) => (
            <details className="vc-faq-item" key={i}>
              <summary>{f.q}</summary>
              <p>{f.a}</p>
            </details>
          ))}
        </div>
      </div>

      <style>{`
        .vc-wrap { max-width: 1100px; margin: 0 auto; padding: 16px 16px 32px }
        .vc-headline h1 { font-size: 26px; font-weight: 900; color: var(--cl-navy); letter-spacing: -.02em }
        .vc-headline p { font-size: 14px; color: var(--cl-muted); margin-top: 4px; line-height: 1.5 }

        .vc-hero {
          margin-top: 18px; padding: 22px;
          background: linear-gradient(135deg, #ecfdf5, #d1fae5);
          border: 1px solid #86efac; border-radius: 18px;
        }
        .vc-hero-top { display: flex; align-items: center; gap: 18px; margin-bottom: 16px }
        .vc-hero-num {
          font-size: 56px; font-weight: 900; color: #065f46; letter-spacing: -.04em;
          line-height: 1; flex-shrink: 0;
        }
        .vc-hero-h { font-size: 18px; font-weight: 800; color: #065f46; line-height: 1.3 }
        .vc-hero-sub { font-size: 13px; color: #047857; margin-top: 6px; line-height: 1.5 }

        .vc-bar { background: rgba(5,150,105,.18); height: 10px; border-radius: 999px; overflow: hidden }
        .vc-bar-fill { background: linear-gradient(90deg, #16a34a, #4ade80); height: 100%; transition: width .4s }
        .vc-bar-meta { display: flex; justify-content: space-between; margin-top: 6px; font-size: 11px; font-weight: 700; color: #047857 }

        .vc-cta {
          margin-top: 16px; width: 100%;
          background: #25d366; color: #fff; border: 0;
          padding: 14px 22px; border-radius: 999px;
          font-size: 15px; font-weight: 800; cursor: pointer; font-family: inherit;
          display: flex; align-items: center; justify-content: center; gap: 10px;
          box-shadow: 0 8px 20px rgba(37,211,102,.3);
          transition: transform .15s, box-shadow .15s;
        }
        .vc-cta:hover { transform: translateY(-2px); box-shadow: 0 12px 26px rgba(37,211,102,.4) }
        .vc-cta span { font-size: 18px }

        .vc-section { font-size: 16px; font-weight: 900; color: var(--cl-navy); margin: 28px 0 14px; letter-spacing: -.01em }

        .vc-steps { display: grid; grid-template-columns: 1fr; gap: 12px }
        .vc-step {
          background: var(--cl-card); border: 1px solid var(--cl-line);
          border-radius: 14px; padding: 18px;
          position: relative;
        }
        .vc-step-num {
          position: absolute; top: -10px; left: 16px;
          background: var(--cl-navy); color: #fff;
          width: 28px; height: 28px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; font-weight: 800;
        }
        .vc-step-icon { font-size: 28px; margin-bottom: 8px; margin-top: 6px }
        .vc-step-titulo { font-size: 14px; font-weight: 800; color: var(--cl-navy) }
        .vc-step-texto { font-size: 12.5px; color: var(--cl-muted); margin-top: 4px; line-height: 1.5 }

        .vc-faq { display: flex; flex-direction: column; gap: 10px }
        .vc-faq-item { background: var(--cl-card); border: 1px solid var(--cl-line); border-radius: 12px; padding: 0 16px }
        .vc-faq-item summary { padding: 14px 0; cursor: pointer; font-size: 13px; font-weight: 700; color: var(--cl-navy); list-style: none; position: relative; padding-right: 28px }
        .vc-faq-item summary::-webkit-details-marker { display: none }
        .vc-faq-item summary::after { content: '＋'; position: absolute; right: 0; top: 14px; color: var(--cl-muted2); font-weight: 800 }
        .vc-faq-item[open] summary::after { content: '−' }
        .vc-faq-item p { font-size: 13px; color: var(--cl-muted); line-height: 1.55; padding: 0 0 16px }

        @media (min-width: 700px) {
          .vc-steps { grid-template-columns: 1fr 1fr 1fr }
        }
        @media (min-width: 900px) {
          .vc-wrap { padding: 36px 44px }
          .vc-headline h1 { font-size: 32px }
          .vc-hero { padding: 28px 30px }
          .vc-hero-num { font-size: 72px }
          .vc-hero-h { font-size: 22px }
          .vc-hero-sub { font-size: 14px }
          .vc-section { font-size: 18px; margin: 32px 0 16px }
          .vc-step { padding: 22px }
        }
      `}</style>
    </ClienteLayout>
  )
}
